import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { zCandidateTier, zInterestRole } from 'client/zod.gen';

export const Route = createFileRoute(
  '/_private/_route/_internal/candidates/new/',
)({
  validateSearch: z.object({
    from: z.string().optional().catch(undefined),
    // Set by the Notion "Import to Contender" formula link; triggers autotag hydration.
    fromNotionId: z.string().optional().catch(undefined),
    firstName: z.string().optional().catch(undefined),
    lastName: z.string().optional().catch(undefined),
    email: z.string().optional().catch(undefined),
    company: z.string().optional().catch(undefined),
    linkedinUrl: z.string().optional().catch(undefined),
    // Enum params carry canonical values (source-normalized); invalid values
    // are dropped so a bad link can't wedge the form. `candidateTier` is
    // deliberately NOT named `tier`: the parent `_private` route already owns a
    // `tier` list-filter search param (zFiltersArray) that would clobber it.
    candidateTier: zCandidateTier.optional().catch(undefined),
    interestRoleOperating: zInterestRole.optional().catch(undefined),
    interestRoleBoardAdvisory: zInterestRole.optional().catch(undefined),
    // Comma-delimited, matching the bulk CSV import's keyword parsing.
    keywords: z.string().optional().catch(undefined),
    notes: z.string().optional().catch(undefined),
  }),
});
